export default "__VITE_ASSET__CvhGouJR__"